<ion-header>
  <ion-toolbar>
    <ion-buttons slot="start">
      <ion-back-button defaultHref="/video-stream-providers"></ion-back-button>
    </ion-buttons>
    <ion-title>Track.Tennis</ion-title>
  </ion-toolbar>
</ion-header>

<ion-content>

  <div class="content-width">
    <ion-list>
      <ion-item *ngFor="let partner of videoStreamProviderList; let i = index">
        <ion-avatar slot="start">
          <img [src]="getAvatarImg(partner.partner.username)" />
        </ion-avatar>
        <ion-label>
          {{partner.partner.name}}
          <p>Courts: {{ partner.cameras?.length }}</p>
        </ion-label>

        <ion-button slot="end" (click)="viewCameras(i)" fill="clear">
          <ion-icon slot="icon-only" name="eye"></ion-icon>
        </ion-button>
      </ion-item>
    </ion-list>
    
  </div>
</ion-content>